// userSelectors.js

export const selectLoading = (state) => state.passport.loading;
export const selectPassportData = (state) => state.passport.passportData;
export const selectedPrescriptionData = (state) => state.passport.prescriptionData;
export const selectedHealthRecData = (state) => state.passport.healthRecData;